function createElementFromHTML(htmlString) {
  let div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes
  return div.firstChild;
}

function normaliseElement(formElement) {
  if (typeof formElement == 'string') {
    return document.querySelector(formElement);
  }
  return formElement;
}

export default class FormValidator {
  /*
  * @property rules
  * @property formElement
  * @property errorMessageElement
  * */
  constructor(rules, formElement) {
    /* Rule can be [key, errorMessage, validator(){...}, elementToScrollTo] */
    this.rules = rules;
    this.formElement = normaliseElement(formElement);
    formElement.addEventListener('submit', (e) => {
      if (!this.validate()) {
        this.renderErrors();
        e.preventDefault();
      }
    })
  }

  validate() {
    const errors = this.generateErrors();
    return !errors.length;
  }

  generateErrors() {
    const errors = [];
    for (let rule of this.rules) {
      const [key, errorMessage, validator, elementToScrollTo] = rule;
      if (!validator.call(null, new FormData(this.formElement))) {
        errors.push([
          key, errorMessage, elementToScrollTo
        ])
      }
    }
    return errors;
  }

  renderErrors() {
    const errors = this.generateErrors();
    let errorMessageHTML = `
<div class='form__group form__group--1-col'>
    <div class="form__item">
        <div class="basic-form-item basic-form-item--has-error">
            <ul class="validation-errors">
                ${errors.map(e => `<li class='validation-errors__item'>
<svg class='validation-errors__icon' viewBox="0 0 70 63" xmlns="http://www.w3.org/2000/svg">
<path d="M63.4 62.2H6.4C4.3 62.2 2.3 61.1 1.2 59.2C0.1 57.3 0.1 55.1 1.2 53.2L29.7 3.90002C30.8 2.00002 32.7 0.900024 34.9 0.900024C37.1 0.900024 39 2.00002 40.1 3.90002L68.6 53.2C69.7 55.1 69.7 57.3 68.6 59.2C67.4 61.1 65.5 62.2 63.4 62.2ZM34.9 4.20004C33.9 4.20004 33 4.70004 32.6 5.60004L4.10001 54.9C3.60001 55.7 3.60001 56.8 4.10001 57.6C4.60001 58.4 5.5 59 6.4 59H63.4C64.4 59 65.3 58.5 65.7 57.6C66.2 56.8 66.2 55.7 65.7 54.9L37.2 5.60004C36.7 4.70004 35.8 4.20004 34.9 4.20004Z" fill="black"/>
<path d="M35.2004 43.5001H34.5004C33.6004 43.5001 32.9004 42.8001 32.9004 41.9001V17.9001C32.9004 17.0001 33.6004 16.3 34.5004 16.3H35.2004C36.1004 16.3 36.8004 17.0001 36.8004 17.9001V41.9001C36.8004 42.8001 36.1004 43.5001 35.2004 43.5001Z" fill="black"/>
<path d="M35.3 52.0001H34.6C33.7 52.0001 33 51.3001 33 50.4001V48.4001C33 47.5001 33.7 46.8 34.6 46.8H35.3C36.2 46.8 36.9 47.5001 36.9 48.4001V50.4001C36.9 51.3001 36.2 52.0001 35.3 52.0001Z" fill="black"/>
</svg>
<a href="#" class="validation-errors__text" data-error-key="${e[0]}">${e[1]}</a>
<li>`).join('')}    
            </ul>
            <label class="basic-form-item__label">Your submission has following errors</label>
            <div class="basic-form-item__instruction">Click on the error will scroll the corresponding field into view.</div>
        </div>
    </div>    
</div>
    `;
    // Remove previous error message element if any
    if (this.errorMessageElement) {
      this.errorMessageElement.remove();
    }
    this.errorMessageElement = createElementFromHTML(errorMessageHTML);
    this.formElement.querySelector('.form__inner').appendChild(this.errorMessageElement);

    // Bind click event
    Array.prototype.forEach.call(this.formElement.querySelectorAll('.validation-errors__text'), (el) => {
        el.addEventListener('click', ev => {
          ev.preventDefault();
          let errorKey = el.getAttribute('data-error-key');
          let error = errors.find(e => e[0] == errorKey);
          let targetField = normaliseElement(error[2]);
          if (targetField) {
            targetField.scrollIntoView();
          }
        })
    });
  }
}